import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Constants from '../../utils/constants';
import { getShiftDetails, getSelectedShiftInfo, getCheckLists, completeShift, getLoading, showExtraRating, hasShiftEnd,getTaskAssignees,getSelectedAssignees } from './shiftDetailsSlice';
import { getSelectedDepartment } from '../DepartmentList/departmentsSlice';
// import { getSelectedEmployee,getEmployees,getAllEmployees } from '../EmployeeList/employeesSlice';
import { ShiftDetailsUIStyles } from './style';
import { Box, Button, Container, TextField, Tooltip } from "../../utils/ui";
import PageLoader from '../../components/loader';
import PageHeader from '../../components/header'
import CheckList from './checklist';
// import EmpRatings from './employeeRatings'
import { useState } from 'react';
import SelectAutoWidth from '../../components/common/dropdown'

const Header = ({ shift }) => {
    const department = useSelector(getSelectedDepartment);
    const shiftTitle = shift.name;
    return (
        <PageHeader heading={shiftTitle} rightSection={department.name} />
    );
}

const NotesFromManager = ({ shift }) => {
    const { HEADERS } = Constants;
    return (
        <div className='notes'>
            <div>{HEADERS.NOTES_FROM_MNGR}</div>
            <ul>
                <div>{shift.description}</div>
            </ul>
        </div>
    );
}

const NotesForManager = ({ setNotesfrMngr }) => {
    const { HEADERS } = Constants;
    const handleChange = (e) => {
        setNotesfrMngr(e.target.value)
    }

    return (
        <div className='notes'>
            <div>{HEADERS.NOTES_FOR_MNGR}</div>
            <TextField
                onChange={handleChange}
                className='notesForMNGR'
                placeholder=""
                multiline
                rows={2}
                maxRows={Infinity}
            />
        </div>
    );
}

export default function ShiftDetails() {
    const { ACTIONS } = Constants;
    // const [showRatings, setRatings] = useState(false)
    const [notesfrMngr, setNotesfrMngr] = useState('')
    const shift = useSelector(getShiftDetails);

    const shiftTitle = shift?.name?.toLowerCase()|| '';
    const isShiftIncluded = shiftTitle.includes('shift');

    const checklistArray = useSelector(getCheckLists);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector(getLoading);
    const hasExtraRating = useSelector(showExtraRating);
    const hasShiftCompleted = useSelector(hasShiftEnd);
    const department = useSelector(getSelectedDepartment);
    const userList = useSelector(getTaskAssignees);
    const employee = useSelector(getSelectedAssignees);
    let selectedAssignee=userList?.filter(function (entry) { return entry.orderindex === employee.value; });
    const [value, setValue] = React.useState(selectedAssignee?.length?selectedAssignee[0]:{});


    const handleAssigneeChange = (event) => {
        setValue(event.target.value);
    };


    /**Get Shift/task details */
    useEffect(() => {
        dispatch(getSelectedShiftInfo())
    }, [dispatch]);

    /**show rating screen */
    useEffect(() => {
        // setRatings(hasShiftCompleted);
        if (hasShiftCompleted) {
            navigate(`${Constants.ROUTES.DEPARTMENT_LIST}/${department.id}${Constants.ROUTES.SHIFT_LIST}`);
        }
    }, [hasShiftCompleted]);


    const handleEndShifts = (e) => {
        e.preventDefault();

        let chekListsResolvedCount = 0;
        checklistArray.forEach(chkElement => {
            if (!chkElement.unresolved) {
                chekListsResolvedCount++;
            }
        });

        // let rating = 0;
        let status = '';
        if (chekListsResolvedCount === checklistArray.length) {
            // rating = 4;
            status = Constants.SHIFT.STATUS.CLOSED;
        }
        else {
            // status=Constants.SHIFT.STATUS.IN_REVIEW;
            status = Constants.SHIFT.STATUS.CLOSED;
            // rating = Math.floor((chekListsResolvedCount / checklistArray.length) * 4);
        }

        // if (notesfrMngr.trim()) {
        //     rating++;
        // }
        let hasChecklistCompletedWithCommentsAdded = false;
        if (chekListsResolvedCount === checklistArray.length && notesfrMngr.trim()) {
            hasChecklistCompletedWithCommentsAdded = true;
        }

        dispatch(completeShift({
            shiftId: shift.id,
            hasChecklistCompletedWithCommentsAdded: hasChecklistCompletedWithCommentsAdded,
            bodyData: {
                status: status,
                comment_text: notesfrMngr,
                // rating: rating,
                employee: {
                    id: employee.id,
                    value: value.orderindex
                }
            }
        }));
    };

    return (
        <ShiftDetailsUIStyles>
            {isLoading ? <PageLoader /> : ''}
            <Header shift={shift} />
            {/* {!showRatings ? */}
            <div className='shiftDetailBodyContainer'>
            <div className='userlist'><SelectAutoWidth minWidth={150} dropDownList={userList} value={value} inputLabel={Constants.PAGE_HEADER.SELECT_EMP} handleChange={handleAssigneeChange}/></div>
                <NotesFromManager shift={shift} />
                <CheckList checklistArray={checklistArray} />
                <NotesForManager setNotesfrMngr={setNotesfrMngr} />
                <Box sx={{textAlign:"right"}}>
                <Tooltip title={Constants.PAGE_HEADER.BTN_TOOLTIP}>
                    <Button onClick={handleEndShifts} className='endShiftButton'>{isShiftIncluded ? ACTIONS.END_SHIFT : ACTIONS.CLOSE}</Button>
                </Tooltip>    
                </Box>
            </div>
            {/* : */}
            {/*  <EmpRatings notesfrMngr={hasExtraRating} /> */}
            {/* } */}
        </ShiftDetailsUIStyles>
    )
}